import { render, staticRenderFns } from "./UserLogins.vue?vue&type=template&id=a72898ac&scoped=true&"
import script from "./UserLogins.vue?vue&type=script&lang=ts&"
export * from "./UserLogins.vue?vue&type=script&lang=ts&"
import style0 from "./UserLogins.vue?vue&type=style&index=0&id=a72898ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72898ac",
  null
  
)

export default component.exports